__turbopack_context__.v({
  "actionWrapper": "G0IJtG_actionWrapper",
  "available": "G0IJtG_available",
  "container": "G0IJtG_container",
  "contentWrapper": "G0IJtG_contentWrapper",
  "descriptionHeader": "G0IJtG_descriptionHeader",
  "descriptionText": "G0IJtG_descriptionText",
  "descriptionWrapper": "G0IJtG_descriptionWrapper",
  "disabled": "G0IJtG_disabled",
  "discountValue": "G0IJtG_discountValue",
  "iconCheck": "G0IJtG_iconCheck",
  "iconX": "G0IJtG_iconX",
  "unavailable": "G0IJtG_unavailable",
  "used": "G0IJtG_used",
  "usedTooltip": "G0IJtG_usedTooltip",
  "valueWrapper": "G0IJtG_valueWrapper",
});
